<template>
  <div v-if="obj">
    <el-drawer :visible="visible" direction="ttb" :with-header="false" size="100%">
      <!-- <van-popup v-model="visible" position="top" class="HideScrollbar"> -->
      <div class="main">
        <!-- <van-nav-bar fixed placeholder> </van-nav-bar> -->
        <!-- {{ bkmenu }} -->
        <!-- {{ obj }} -->
        <h3>
          <el-button class="back" type="text" icon="el-icon-back" @click="onCancel" />
          {{ obj.itemname }}
        </h3>
        <!-- {{ obj }} -->
        <el-form ref="form" :model="obj" label-width="120px">
          <el-form-item label="顯示名稱">
            <el-input v-model="obj.dispname" placeholder="名稱"></el-input>
          </el-form-item>

          <el-form-item label="價別">
            <el-checkbox v-model="obj.pricecap"
              >使用POS價別表示不同份量(例：小、中、大)</el-checkbox
            >
          </el-form-item>
          <el-form-item label="商品圖片">
            <!-- <van-image
              :src="obj.imgfile"
              width="80"
              lazy-load
              @click="$refs.rImagePick.show(obj)"
            /> -->
            <ImagePicker
              :r="{ label: '', value: obj.imgfile }"
              @pick="obj.imgfile = $event"
            />
          </el-form-item>
          <el-form-item label="說明(選填)">
            <el-input
              type="textarea"
              v-model="obj.desc"
              :autosize="{ minRows: 5, maxRows: 10 }"
            ></el-input>
          </el-form-item>

          <el-form-item label="分類標籤">
            <el-select
              v-model="obj.tags"
              multiple
              filterable
              default-first-option
              allow-create
              placeholder="請選擇"
              @change="onChange"
              style="width: 300px"
            >
              <el-option
                v-for="(r, index) in tagOptions"
                :key="index"
                :label="r"
                :value="r"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="促銷">
            <Discount :discount="obj.discount" @change="setDiscount" />
          </el-form-item>
          <!-- {{ options }} -->
          <el-form-item label="客製化群組">
            <el-select
              v-model="options"
              multiple
              filterable
              default-first-option
              placeholder="請選擇"
            >
              <el-option
                v-for="r in bkmenu.extgroup"
                :key="r.id"
                :label="r.id"
                :value="r.id"
              >
              </el-option>
            </el-select>

            <el-button @click="addOptions()">加入</el-button>
            <!-- {{ obj.groups }} -->
            <el-table
              :data="obj.groups"
              stripe
              style="width: 100%"
              :show-header="false"
              empty-text="無客製化項目"
            >
              <el-table-column label="類別編號">
                <template slot-scope="scope">
                  {{ scope.row }}
                </template>
              </el-table-column>

              <el-table-column align="right" width="120">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index)"
                  />
                </template>
              </el-table-column>
              <el-table-column align="right" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    icon="el-icon-top"
                    circle
                    @click="cmdUp(scope.$index, scope.row)"
                  />
                  <el-button
                    size="mini"
                    icon="el-icon-bottom"
                    circle
                    @click="cmdDown(scope.$index, scope.row)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item>
            <el-button @click="onOk">儲存</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- <ImagePick ref="rImagePick" @pick="onPick" /> -->
      <FrmItemDetail ref="rFrmItemDetail" />
      <!-- </van-popup> -->
    </el-drawer>
  </div>
</template>

<style scoped>
.back {
  font-size: 2rem;
}
.van-popup {
  width: 100%;
  height: 100%;
}
.main {
  font-size: 1.6rem;
  /* line-height: 4rem; */
  padding: 1rem;
  text-align: left;
}
</style>

<script>
// var fits = require("../../../../js/lib-fits-front.js");
// var fits = require("../../../js/lib-fits-front.js");
export default {
  data() {
    return {
      visible: false,
      obj: null,
      objString: "",
      bkmenu: null,
      options: [],
      tagOptions: [],
    };
  },
  methods: {
    cmdUp(index, row) {
      if (index < 1) {
        return;
      }
      // var exttype = this.bkmenu.exttype;
      var groups = this.obj.groups;
      groups.splice(index, 1);
      groups.splice(index - 1, 0, row);
    },
    cmdDown(index, row) {
      // var exttype = this.bkmenu.exttype;

      var groups = this.obj.groups;
      if (index > groups.length - 2) {
        return;
      }
      groups.splice(index, 1);
      groups.splice(index + 1, 0, row);
    },
    loadTagOptions() {
      let array = [];
      this.bkmenu.extitem.forEach((el) => {
        array = array.concat(el.tags);
        // array.push(el.tags);
      });
      array = [...new Set(array)];
      array.sort();
      this.tagOptions = array;
    },
    onChange(pValue) {
      console.log("onChange", pValue);
      this.loadTagOptions();
      // this.tagOptions = this.tagOptions.concat(pValue);
      // this.tagOptions.sort();
      let array = this.tagOptions.concat(pValue);
      array = [...new Set(array)];
      array.sort();
      this.tagOptions = array;
      // this.tagOptions = array;
    },
    addOptions() {
      this.options.forEach((r) => {
        // let row = {};
        // r = JSON.parse(r);
        // row.TypeNo = r.TypeNo;
        // row.ItemName = r.ItemName;
        // row.KPtype = r.KPtype;
        // row.ItemCode = r.ItemCode;
        // row.Price1 = r.Price1;

        this.obj.groups.push(r);
      });
      this.options = [];
    },
    onPick(row, url) {
      console.log("pick", row, url);
      this.obj.imgfile = url;
    },
    async init() {
      try {
        var res = await this.apiGetBKMenu();
        this.bkmenu = res.data;
        this.options = [];
      } catch (error) {
        console.log(error.toString());
      }
    },
    async showEdit(rowIndex, obj) {
      try {
        await this.init();
        console.log("show", rowIndex);
        this.loadTagOptions();
        var find = this.bkmenu.extitem.find((r) => r.itemname == obj.ItemName);
        if (find) {
          // update
          if (!find.pricecap) find.pricecap = false;
          this.objString = JSON.stringify(find);
          this.obj = JSON.parse(this.objString);

          if (!Array.isArray(this.obj.discount)) {
            this.obj.discount = [];
          }
          this.visible = true;
          console.log("old", find);
        } else {
          // create new
          console.log("new", obj.ItemName);
          //第二件半價
          // var dc = { type: "dc",text:"買1送1", qty: 2, range: 1, rate: 0 }; //
          // var dc = { type: "dc",text:"第2件5折", qty: 2, range: 1, rate: 50 }; //
          // var dc = { type: "dc",text:"買2件7折", qty: 2, range: 2, rate: 70 }; //
          // var dc = { type: "dc",text:"買5件55折", qty: 5, range: 5, rate: 55 }; //

          this.obj = {
            itemname: obj.ItemName,
            dispname: "",
            imgfile: "",
            desp: "",
            discount: [],
            groups: [],
            pricecap: false,
          };
          this.visible = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    onCancel() {
      this.obj = null;
      this.visible = false;
    },
    async onOk() {
      var body = this.obj;
      var res = await this.apiUpdateExtitem(body);
      console.log("res", res);
      this.visible = false;
      this.obj = null;
      this.$emit("ok");
    },
    async handleDelete(rowIndex) {
      this.obj.groups.splice(rowIndex, 1);
    },
    setDiscount(row) {
      // console.log("setDiscount", row);

      // return (this.obj.discount = row);
      this.obj.discount = [];
      if (row != "") {
        this.obj.discount.push(row);
      }
    },
  },
};
</script>
